// initial state
const state = {
    list: jsonData.contacts.list,
}

// getters
const getters = {
    all: (state) => state.list,
    get: (state) => (name) => state.list.find((contact) => contact.name.toLowerCase() === name),
}

// actions
const actions = {}

// mutations
const mutations = {}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
